export default "__VITE_ASSET__BvUFDZRY__"